import { curriedUrlChanger } from 'components/Common/utils'

export const urlChanger = curriedUrlChanger('/settings/terms-and-conditions')
